<template>
    <div class="c-wrapper">
        <h5 class="c-title">{{data.title}}</h5>
        <div class="c-cont-wrap">
            <template v-for="(item, index) in data.list">
                <!--标题1-->
                <h1 v-if="item.type == 'h1'" :key="index">{{item.desc}}</h1>
                <!--标题2-->
                <h2 v-if="item.type == 'h2'" :key="index">{{item.desc}}</h2>
                <!--标题3-->
                <h3 v-if="item.type == 'h3'" :key="index">{{item.desc}}</h3>
                <!-- 斜体 -->
                <i v-if="item.type == 'i'" class="c-wrap-i" :key="index">{{item.desc}}</i>
                <!--段落-->
                <p v-if="item.type == 'p'" class="c-wrap-row" :key="index">{{item.desc}}</p>
                <!--无序号列表-->
                <ul v-if=" item.type == 'ul' " :key="index" class="c-wrap-ul">
                    <li v-for="(itemul, indexul) in item.list" :key="indexul" class="c-wrap-ol-li">{{itemul.desc}}</li>
                </ul>
                <!-- 图片 -->
                <img v-if="item.type == 'img'" class="c-img" :key="index" :src="item.desc"/>
                <!-- email -->
                <a v-if="item.type == 'email'" class="c-email" :href="`mailto:${item.desc}`" :key="index" >{{item.desc}}</a>
            </template>


            <!--test-->
            <!-- <div style="height:200px;"></div>
            <h1>我们收集的个人信息</h1>
            <h2>个人信息的定义</h2>
            <h2>收集个人信息的时机</h2>

            <h1>我们收集的个人信息</h1>
            <h2>个人信息的定义</h2>
            <h2>收集个人信息的时机</h2>
            <h3>请求驳回</h3>
            <h3>请求驳回</h3>
            <h2>收集个人信息的时机 2</h2>
            <h3>请求驳回2</h3>
            <h3>请求驳回2</h3> -->
        </div>
    </div>
</template>

<script>
import V3_1 from '../../static/langPack/V3/V3-1.png'
import V3_2 from '../../static/langPack/V3/V3-2.png'
import V3_3 from '../../static/langPack/V3/V3-3.jpg'
export default {
    name: "cellPreface",
    props: [ 'wrapData' ],
    data() {
       return {
       }
    },
    watch: {
        wrapData(val) {
            // console.log(val)
        }
    },
    computed: {
        data() {
            return this.wrapData;
        },
    },
    methods: {

    },
    created() {
        // console.log('cellGlossary wrapData: ' + JSON.stringify(this.data))
    },
}
</script>

<style scoped>
/** 当前 1rem = 28px */
.c-title { font-size: .6rem; text-align: center; margin-bottom: 1rem; }
.c-img { width: 100px; height: 100px;margin: 0.5rem 0;}
.c-email { margin-left: 2em; }
.c-wrap-i { display: inline-block; margin-top: 0.5rem;}
/*h*/
h1 { counter-increment: counter_h1; counter-reset: counter_h2; }
h1::before {  content: counter(counter_h1)""; }

h2 { counter-increment: counter_h2; counter-reset: counter_h3; }
h2::before { content: counter(counter_h1)"."counter(counter_h2); }

h3 { counter-increment: counter_h3; }
h3::before { content: "("counter(counter_h3)")"; }
 /* counter(counter_h1)"."counter(counter_h2)"."counter(counter_h3) */

h1::before, h2::before, h3::before { padding-right: .5em; }

h1 { margin-bottom: 0.5rem; margin-top: 0.5rem; font-weight: bold; }
h2 { margin-bottom: 0.2rem; font-size: 0.5rem; }
h3 { margin-bottom: 0.2rem; font-size: 0.5rem; }
</style>



// WEBPACK FOOTER //
// src/components/cell-content.vue